import { css, jsx } from '@emotion/react';
import { AlertBanner } from '../AlertBanner';
import { withModifier } from '@zapier/style-encapsulation';
import { UNIVERSAL_NAV_ZINDEX, UNIVERSAL_TOPBAR_CONDENSED_HEIGHT, UNIVERSAL_TOPBAR_HEIGHT, } from '../../../universal-nav/constants';
import { UniversalFooter } from '../../../universal-footer/components/UniversalFooter';
import { UniversalLayoutQueryContainer } from './UniversalLayoutQueryContainer';
import { UniversalNav } from '../../../universal-nav/components/UniversalNav';
import { UniversalNavProvider } from '../../../universal-nav/hooks';
import { useUniversalNavContext } from '../../../universal-nav/hooks/useUniversalNavContext';
import { shouldRenderTopbarLinksForRoute } from '../../../universal-nav/hooks';
const Styles = {
    root: css `
    display: block;
  `,
    alertBanner: css `
    &:empty {
      display: none;
    }
  `,
    grid: css `
    min-height: 100vh;
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto 1fr auto;
    grid-template-areas:
      'head'
      'main'
      'foot';
    gap: 0;
  `,
    gridWithSidebar: (sidebarWidth) => css `
    grid-template-columns: ${sidebarWidth}px 1fr;
    grid-template-areas:
      'head head'
      '.... main'
      '.... foot';
  `,
    head: (shouldHeaderStickToTop) => [
        css `
      grid-area: head;
      // Stickiness is handled by UniversalNav but needs
      // to be reinforced here to work properly.
      position: sticky;
      z-index: ${UNIVERSAL_NAV_ZINDEX};
      top: -${UNIVERSAL_TOPBAR_CONDENSED_HEIGHT}px;

      @media (min-width: 450px) {
        top: -${UNIVERSAL_TOPBAR_HEIGHT}px;
      }
    `,
        shouldHeaderStickToTop &&
            withModifier('stuck-to-top', css `
          top: 0;
        `),
    ],
    main: css `
    grid-area: main;
    position: relative;
  `,
    foot: css `
    grid-area: foot;
  `,
};
const UniversalLayoutInner = (props) => {
    const { sidebarWidth } = useUniversalNavContext();
    const shouldHeaderStickToTop = shouldRenderTopbarLinksForRoute({
        currentUrl: props.currentUrl,
        mode: props.mode,
    });
    return (jsx("div", { css: Styles.root, "data-zds": true },
        props.renderAlertBanner && (jsx("div", { css: Styles.alertBanner, "data-testid": "UniversalLayoutAlertBanner", "data-zds": true }, props.renderAlertBanner(props))),
        jsx("div", { css: [
                Styles.grid,
                sidebarWidth && Styles.gridWithSidebar(sidebarWidth),
            ], "data-zds": true },
            props.renderHeader && (jsx("div", { css: Styles.head(shouldHeaderStickToTop), "data-zds": true }, props.renderHeader(props))),
            jsx("main", { css: Styles.main, id: props.mainContentId, "data-zds": true }, props.children),
            props.renderFooter && (jsx("div", { css: Styles.foot, "data-zds": true }, props.renderFooter(props))))));
};
export const UniversalLayout = ({ children, currentUrl, shouldSidebarBeInitiallyCollapsed = false, trackEvent, accountData = undefined, accountsListData = undefined, apiHostname = '', bffHostname = '', mainContentId = 'mainContent', mode = undefined, sessionData = undefined, shouldRenderAlphabetNav = undefined, shouldRenderSeoLinks = undefined, shouldRenderTOS = undefined, showSimplifiedFooter = undefined, urlPathPrefix = undefined, renderAlertBanner = (props) => (jsx(AlertBanner, { trackEvent: props.trackEvent })), renderNotifications = () => null, renderHeader = (props) => {
    return (jsx(UniversalNav, { renderNotifications: props.renderNotifications, skipLinkHref: `#${props.mainContentId}` }));
}, renderFooter = (props) => {
    return (jsx(UniversalFooter, { shouldRenderAlphabetNav: props.shouldRenderAlphabetNav, shouldRenderSeoLinks: props.shouldRenderSeoLinks, showSimplifiedFooter: props.showSimplifiedFooter }));
}, }) => {
    const props = {
        children,
        currentUrl,
        trackEvent,
        accountData,
        accountsListData,
        apiHostname,
        bffHostname,
        mainContentId,
        mode,
        sessionData,
        shouldRenderAlphabetNav,
        shouldRenderSeoLinks,
        shouldRenderTOS,
        showSimplifiedFooter,
        urlPathPrefix,
        renderAlertBanner,
        renderNotifications,
        renderHeader,
        renderFooter,
    };
    return (jsx(UniversalLayoutQueryContainer, null,
        jsx(UniversalNavProvider, { accountData: accountData, accountsListData: accountsListData, shouldSidebarBeInitiallyCollapsed: shouldSidebarBeInitiallyCollapsed, currentUrl: currentUrl, urlPathPrefix: urlPathPrefix, sessionData: sessionData, mode: mode, shouldRenderTOS: shouldRenderTOS, apiHostname: apiHostname, bffHostname: bffHostname },
            jsx(UniversalLayoutInner, Object.assign({}, props)))));
};
//# sourceMappingURL=UniversalLayout.js.map
// @zapier/universal-layout@9.12.4 (a02ac1bd0)
